import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// Loads the Routes (code -> name) and Locations (number -> store) catalogs once
// and exposes label helpers used across the reconciliation UI.
export function useCatalogs() {
  const { data: routes } = useQuery({
    queryKey: ["routes-catalog"],
    queryFn: async () => (await api.get("/recon/routes")).data,
    staleTime: Infinity,
  });
  const { data: locs } = useQuery({
    queryKey: ["locations-catalog"],
    queryFn: async () => (await api.get("/recon/locations")).data,
    staleTime: Infinity,
  });

  const routeMap = {};
  (routes?.items || []).forEach((r) => { routeMap[r.route_code] = r.route_name; });
  const locMap = {};
  (locs?.items || []).forEach((l) => { locMap[l.number] = l.description; });

  return {
    routeName: (code) => (code ? routeMap[code] || null : null),
    locationName: (code) => (code ? locMap[code] || null : null),
    routes: routes?.items || [],
    locations: locs?.items || [],
  };
}
